import styled, { css } from 'styled-components';
export const InlineAlertBase = styled.div `
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  align-items: top;

  max-width: 560px;
  margin: 0px;

  line-height: 24px;

  & > i {
    flex-shrink: 0;

    color: var(--color-info-accent);
    font-size: 24px;

    margin: 16px 24px 16px 16px;
  }

  ${({ $variant }) => $variant === 'error' &&
    css `
      outline-color: var(--color-error-accent);

      & > i {
        color: var(--color-error-accent);
      }
    `}

  ${({ $variant }) => $variant === 'warning' &&
    css `
      outline-color: var(--color-warning-accent);

      & > i {
        color: var(--color-warning-accent);
      }
    `}

  ${({ $variant }) => $variant === 'success' &&
    css `
      outline-color: var(--color-success-accent);

      & > i {
        color: var(--color-success-accent);
      }
    `}
`;
export const Title = styled.div `
  /*
  The 12px is due to the line height being 24px instead of 16px as is in the design.
  Must have 24px line height to support multiline.
  16px (original line height) - 24px (multiline line height) = -8px (difference).
  Then those -8px is distributed to top and bottom margins, -4px to each.
  */

  display: flex;
  align-items: center;
  padding: 16px 0;

  color: var(--color-on-background);

  font-size: 16px;
  font-weight: 600;
`;
